export default __webpack_public_path__ + "static/media/multi-device.5bfa2566.svg";